import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from '@app/models/util/paginacao';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

import { ToastrService } from 'ngx-toastr';
import { Area } from '@app/models/area';
import { AreaService } from '@app/services/area.service';

@Component({
  selector: 'app-area-lista',
  templateUrl: './area-lista.component.html'
})

export class AreaListaComponent implements OnInit {

  lstArea: Area[];
  paginacao: Paginacao;
  filtroDescricao: string = '';
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private areaService: AreaService,
    private modalService: BsModalService
  ) {
    this.paginacao = new Paginacao();
  }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.areaService.obterLista("", 1).subscribe(
      (areas: Area[]) => {
        this.lstArea = areas;
      },
      (erro) => {
        console.error('Erro ao obter a lista de áreas:', erro);
      }
  );
  }

  deletar(area: Area) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente excluir a area: ' + area.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.areaService.deletar(area.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
